const testimonials = [
  {
    id: 1,
    name: 'Sarah Mitchell',
    location: 'Fort Worth, TX',
    rating: 5,
    text: 'I saved over $9,000 compared to the first quote I got! The instant estimate was spot-on, and the contractor they matched me with did excellent work. No pressure, just honest pricing.',
    image: 'https://public.readdy.ai/ai/img_res/7ea370b6094d9fbd2dbc68a4a97d4120.jpg',
    project: 'Complete Roof Replacement'
  },
  {
    id: 2,
    name: 'Michael Rodriguez',
    location: 'Dallas, TX',
    rating: 5,
    text: 'Finally, a roofing service that puts homeowners first! Got my estimate instantly, connected with a great contractor, and kept thousands more in my pocket. This is how it should be done.',
    image: 'https://readdy.ai/api/search-image?query=professional%20man%20homeowner%20smiling%20portrait%20headshot%20friendly%20confident%20natural%20lighting%20casual%20attire%20authentic%20real%20person%20photography&width=160&height=160&seq=testimonial-002&orientation=squarish',
    project: 'Insurance Claim & Replacement'
  },
  {
    id: 3,
    name: 'Jennifer Thompson',
    location: 'Arlington, TX',
    rating: 5,
    text: 'The transparent pricing was refreshing. I knew exactly what I was paying for — no hidden fees or surprise charges. The quality exceeded my expectations and I saved $11,000!',
    image: 'https://readdy.ai/api/search-image?query=professional%20woman%20homeowner%20happy%20portrait%20headshot%20warm%20smile%20natural%20lighting%20casual%20professional%20attire%20authentic%20real%20person%20photography&width=160&height=160&seq=testimonial-003&orientation=squarish',
    project: 'Roof Replacement'
  },
  {
    id: 4,
    name: 'David Chen',
    location: 'Plano, TX',
    rating: 5,
    text: 'No pushy salespeople, no pressure tactics. Just fast estimates and quality pros. Got matched with an excellent contractor who did amazing work at a fair price.',
    image: 'https://readdy.ai/api/search-image?query=professional%20asian%20man%20homeowner%20smiling%20portrait%20headshot%20friendly%20confident%20natural%20lighting%20casual%20attire%20authentic%20real%20person%20photography&width=160&height=160&seq=testimonial-004&orientation=squarish',
    project: 'Emergency Repair'
  },
  {
    id: 5,
    name: 'Lisa Anderson',
    location: 'Irving, TX',
    rating: 5,
    text: 'The instant estimate process was incredibly convenient. Got accurate pricing in seconds, reviewed my options at my own pace, and connected with a vetted pro when I was ready. Saved over $10,000!',
    image: 'https://readdy.ai/api/search-image?query=professional%20woman%20homeowner%20smiling%20portrait%20headshot%20friendly%20warm%20natural%20lighting%20casual%20attire%20authentic%20real%20person%20photography&width=160&height=160&seq=testimonial-005&orientation=squarish',
    project: 'Roof Replacement'
  },
  {
    id: 6,
    name: 'Robert Martinez',
    location: 'Grand Prairie, TX',
    rating: 5,
    text: 'This platform gave me back control. I could compare options without salespeople breathing down my neck. The contractor was professional, the work was excellent, and I kept way more money.',
    image: 'https://readdy.ai/api/search-image?query=professional%20hispanic%20man%20homeowner%20smiling%20portrait%20headshot%20friendly%20confident%20natural%20lighting%20casual%20attire%20authentic%20real%20person%20photography&width=160&height=160&seq=testimonial-006&orientation=squarish',
    project: 'Complete Roof Replacement'
  }
];

const TestimonialsGrid = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4 font-['Poppins']">
            What Homeowners Say
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Real stories from homeowners who kept thousands more by cutting out the middleman
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-white rounded-2xl p-8 shadow-sm border border-gray-200 hover:shadow-lg hover:border-[#4A90E2] transition-all"
            >
              <div className="flex items-center mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-xl text-[#FFB800]"></i>
                ))}
              </div>
              <p className="text-gray-700 text-sm leading-relaxed mb-6 italic">
                "{testimonial.text}"
              </p>
              <div className="flex items-center mb-4">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full object-cover mr-4"
                />
                <div>
                  <p className="font-semibold text-gray-900 text-sm">{testimonial.name}</p>
                  <p className="text-gray-600 text-xs">{testimonial.location}</p>
                </div>
              </div>
              <div className="pt-4 border-t border-gray-100">
                <p className="text-xs text-[#4A90E2] font-medium">{testimonial.project}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsGrid;
